import { UserDataInterface } from "@/interfaces/userData.interface";

export const getUserData = (): UserDataInterface => JSON.parse(localStorage.getItem("userData") ?? "{}");
